jQuery_T4NT(document).ready(function($) {
  // any code js

  var arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  };
  function enable_two_finger_scroll(e,flkty){
    var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
    var dx = e.originalEvent.deltaX; 
    if(is_firefox){
      var force = dx*(-3);
    }
    else{
      var force = dx/(-3);
    }
    var empty = Number.isNaN(force);
    if(force != 0 && !empty){
      e.preventDefault();
      flkty.applyForce( force );
      flkty.startAnimation();
      flkty.dragEnd();
    }
  }
  function initializeFlickity($el){
    if($el.hasClass('flickity-enabled')){
      //       console.log('Flickity Already Enabled');
      return;
    }
    else {
      if ($el.find('.sublink_cell').length > 6) {
        var $sublink_slider = $el.flickity({
          "wrapAround": false,
          "cellAlign": "left",
          "draggable": true,
          "contain": true,
          "imagesLoaded": true,
          "lazyLoad": 2,
          "pageDots": false,
          "prevNextButtons": true,
          "selectedAttraction": 0.01,
          "friction": 0.15,
          "freeScroll": true,
          "freeScrollFriction": 0.8
        });
        // Scroll with two Fingers - MouseWheel 
        var flkty = $sublink_slider.data('flickity');
        $('.sublink_slider').on('wheel mousewheel DOMMouseScroll',function(e){
          enable_two_finger_scroll(e,flkty);
        }); 
      }
    }
  }
  function calc_height($el){
    var d_menu = $el.find('.tab-container.current').parents('.d_menu');
    var height = d_menu.height();
    d_menu.parents('.row.lazy_menu.lazy_menu_mega').css('height',height);
    //     console.log('height adjusted');
  }
  $('.type_mega.menu-item').click(function(){
    initializeFlickity($(this).find('.tab-container.current .sublink_slider'));
    calc_height($(this));
  });
  $('.type_mega.menu-item').on("mouseover",function(){
    initializeFlickity($(this).find('.tab-container.current .sublink_slider'));
    calc_height($(this));
    //     console.log('function called...');
  });
  $(document).on("mouseover",'.tab-switcher',function(){
    $(this).parents('.d_menu').find('.tab-switcher').removeClass('active');
    $(this).addClass('active');
    var id = ".id_"+ $(this).data("tab-index");
    $(this).parents('.d_menu').find('.tab-container').removeClass('current');
    $(id).addClass('current');
    initializeFlickity($(this).parents('.d_menu').find('.tab-container.current .sublink_slider'));    
    calc_height($(this).parents('.d_menu'));
  });
});


// ----------------------- Multi-Level Push Menu ---------------------------


(function($) {
  this.MobileNav = function() {
    this.curItem,
      this.curLevel = 0,
      this.transitionEnd = _getTransitionEndEventName();

    var defaults = {
      initElem: "nav.mobile_menu",
      menuTitle: "Menu"
    }

    // Check if MobileNav was initialized with some options and assign them to the "defaults"
    if (arguments[0] && typeof arguments[0] === "object") {
      this.options = extendDefaults(defaults, arguments[0]);
    }

    // Add to the "defaults" ONLY if the key is already in the "defaults"
    function extendDefaults(source, extender) {
      for (option in extender) {
        if (source.hasOwnProperty(option)) {
          source[option] = extender[option];
        }
      }
    }

    MobileNav.prototype.getCurrentItem = function() {
      return this.curItem;
    };

    MobileNav.prototype.setMenuTitle = function(title) {
      defaults.menuTitle = title;
      _updateMenuTitle(this);
      return title;
    };    

    // Init is an anonymous IIFE
    (function(MobileNav) {
      var initElem = ($(defaults.initElem).length) ? $(defaults.initElem) : false;

      if (initElem) {
        defaults.initElem = initElem;
        _clickHandlers(MobileNav);
        _updateMenuTitle(MobileNav);
        $("#nt_menu_canvas").addClass('menu_initialized');
        console.log(defaults.initElem + " element exist, menu initialized.");
      } else {
        console.log(defaults.initElem + " element doesn't exist, menu not initialized.");    
      }
    }(this));

    function _getTransitionEndEventName() {
      var i,
          undefined,
            el = document.createElement('div'),
            transitions = {
            'transition': 'transitionend',
            'OTransition': 'otransitionend', // oTransitionEnd in very old Opera
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
          };

      for (i in transitions) {
        if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
          return transitions[i];
        }
      }
    };

    function _clickHandlers(menu) {
      defaults.initElem.on('click', '.has-dropdown > a', function(e) {
        e.preventDefault();
        menu.curItem = $(this).parent();
        _updateActiveMenu(menu);

      });

      defaults.initElem.on('click', '.nav-toggle', function() {
        _updateActiveMenu(menu, 'back');
      });
    };
    
    // set height
    function set_height($el){
      console.log("SET height = " + $el.find('> ul').outerHeight());
      $('.nav-wrapper').height($el.find('> ul').outerHeight());   
    }
    // set height-back
    function set_height_back($el){
      console.log("SET height back = " + $el.parent('ul').outerHeight());
      $('.nav-wrapper').height($el.parent('ul').outerHeight());      
    }
    // TODO: Make this DRY (deal with waiting for transitionend event)
    function _updateActiveMenu(menu, direction) {
      _slideMenu(menu, direction);
      if (direction === "back") {

        menu.curItem.removeClass('nav-dropdown-open nav-dropdown-active');
        set_height_back(menu.curItem);
        menu.curItem = menu.curItem.parent().closest('li');
        menu.curItem.addClass('nav-dropdown-open nav-dropdown-active');
        _updateMenuTitle(menu);
      } else {
        menu.curItem.addClass('nav-dropdown-open nav-dropdown-active');
        set_height(menu.curItem);
        _updateMenuTitle(menu);
      }
    };

    // Update main menu title to be the text of the clicked menu item
    function _updateMenuTitle(menu) {
      var title = defaults.menuTitle;
      if (menu.curLevel > 0) {
        title = menu.curItem.children('a').text();
        defaults.initElem.find('.nav-toggle').addClass('back-visible');
        $('.nav-title').text(title);
      } else {
        defaults.initElem.find('.nav-toggle').removeClass('back-visible');
      }
    };

    // Slide the main menu based on current menu depth
    function _slideMenu(menu, direction) {
      if (direction === "back") {
        menu.curLevel = (menu.curLevel > 0) ? menu.curLevel - 1 : 0;
      } else {
        menu.curLevel += 1;
      }
      defaults.initElem.children('ul').css({
        "transform": "translateX(-" + (menu.curLevel * 100) + "%)"
      });
    };
  }
}(jQuery));

$(document).ready(function() {
  var myVar;
  function initialize_mobile_menu(){
    var MobileMenu = new MobileNav({
      initElem: ".mobile_menu",
      menuTitle: "Masistes",
    });
    var el_cl = $('#nt_menu_canvas').hasClass('menu_initialized');
    if(el_cl){
       clearInterval(myVar);
      $('.push_side').unbind( "click" );
    }
  }
  initialize_mobile_menu();
  $('.push_side').on('click', function(e) {
    e.preventDefault();
    // Due to lazy loading, menu doens't inialize on first try
    // If not initialized before, initialize it on button click
    $('.nav-wrapper').height($('.nav-wrapper .mobile_menu > ul').height());
    myVar = setInterval(initialize_mobile_menu, 500);
  });
});